import { render, staticRenderFns } from "./sare.vue?vue&type=template&id=a22c23d4&scoped=true&"
import script from "./sare.vue?vue&type=script&lang=js&"
export * from "./sare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c23d4",
  null
  
)

export default component.exports